module.exports = __WEBPACK_EXTERNAL_MODULE_121__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 121
 ** module chunks = 0
 **/